export const auth = {
  loggedOut: 'Je bent uitgelogd',
  notIntentional: 'Als dit niet de bedoeling was, kan je ',
  loginAgain: 'opnieuw inloggen',
};
